import Axios from 'axios';

var headers = {
    'Content-Type': 'application/json',


}
const BASE_URL = '/api';

export default {

    getAll() {

        return Axios.get(BASE_URL+ '/bankacc',{ headers: headers });
    },
    add(data) {

        return Axios.post(BASE_URL+ '/bankacc', data,{ headers: headers });
    },

    update(data) {

        return Axios.put(BASE_URL+ '/bankacc/'  +data.id, data,{ headers: headers });
    },

    delete(id) {

        return Axios.delete(BASE_URL  + '/bankacc/'+ id,{ headers: headers });
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/bankaccs.js